import * as React from 'react';
import { renderToString } from 'react-dom/server';
import { useTranslation } from 'react-i18next';

export type StringBuilderWithLinkProps = {
  linkProps: React.AnchorHTMLAttributes<HTMLAnchorElement>;
  linkStrToReplace: string;
  strToBuild: string;
} & React.HTMLAttributes<HTMLSpanElement>;

const StringBuilderWithLink: React.FunctionComponent<StringBuilderWithLinkProps> = (
  props
) => {
  const { t } = useTranslation();
  const { linkProps, linkStrToReplace, strToBuild, ...rest } = { ...props };
  const anchor: JSX.Element = <a {...linkProps}>{t(linkStrToReplace)}</a>;
  const computedString: string = t(strToBuild, { link: '{{link}}' }).replace(
    '{{link}}',
    renderToString(anchor)
  );

  return (
    <span dangerouslySetInnerHTML={{ __html: computedString }} {...rest} />
  );
};

export default StringBuilderWithLink;
